import * as React from "react";
import { typeCompact14Medium } from "@traceair/tds";
import { blue, lightblue, white, red, black, lightred } from "./_colors";
import { style, classes } from "typestyle";
import { NestedCSSProperties } from "typestyle/lib/types";

type ButtonType = "primary" | "secondary" | "control" | "danger" | "disabled";
type ButtonSize = "big" | "medium";
interface IButtonProps {
  className?: string;
  label?: string;
  icon?: React.JSX.Element;
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  type?: ButtonType;
  size?: ButtonSize;
  customStyles?: NestedCSSProperties;
  stretched?: boolean;
  href: string;
  otherAttrs?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}
const ButtonLink = ({
  className,
  size,
  stretched,
  type,
  label,
  icon,
  onClick,
  customStyles,
  href,
  otherAttrs,
}: IButtonProps) => {
  return (
    <a
      href={href}
      onClick={onClick}
      className={classes(
        style({
          boxSizing: "border-box",
          textDecoration: "none",
          fontSize: size === "big" ? "20px" : "14px",
          lineHeight: "24px",
          whiteSpace: "nowrap",
          cursor: "pointer",
          minWidth: label ? "72px" : "0px",
          width: size === "big" || stretched ? "100%" : "auto",
          height: size === "big" ? "56px" : "auto",
          boxShadow:
            size === "big"
              ? "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)"
              : "none",
          padding: stretched ? "8px 16px" : "8px 12px",
          borderRadius: "12px",
          background: getBackgroundColorByType(type),
          color: getTextColorByType(type),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          $nest: {
            "&>*:nth-child(2)": {
              // this style will work when both icon and label are visible
              paddingLeft: size === "big" ? "8px" : "6px",
            },
          },
          ...customStyles,
        }),
        typeCompact14Medium,
        className,
      )}
      {...otherAttrs}
    >
      {icon || null}
      {label && <span>{label}</span>}
    </a>
  );
};

export default ButtonLink;

function getBackgroundColorByType(type?: ButtonType) {
  switch (type) {
    case "primary":
      return blue;
    case "danger":
      return lightred;
    case "control":
      return white;
    case "secondary":
    default:
      return lightblue;
  }
}

function getTextColorByType(type?: ButtonType) {
  switch (type) {
    case "primary":
      return white;
    case "control":
      return black;
    case "danger":
      return red;
    case "secondary":
    default:
      return blue;
  }
}
